import { defineMessages } from 'react-intl';

export const messages: {
	imageFailedMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	warningIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	imageFailedMessage: {
		id: 'company-hub.company-hub-common.link-cards.image-failed-to-load',
		defaultMessage: 'Image failed to load',
		description: "Message shown when the extensions's uploaded image failed to load",
	},
	warningIcon: {
		id: 'company-hub.company-hub-common.link-cards.warning',
		defaultMessage: 'Warning icon for image failed to load',
		description:
			"Label text for a warning icon that's shown when the extensions's uploaded image failed to load",
	},
});
